import { render, staticRenderFns } from "./MailIconLg.vue?vue&type=template&id=c0aabce8&scoped=true&"
import script from "./MailIconLg.vue?vue&type=script&lang=js&"
export * from "./MailIconLg.vue?vue&type=script&lang=js&"
import style0 from "./MailIconLg.vue?vue&type=style&index=0&id=c0aabce8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0aabce8",
  null
  
)

export default component.exports